import { TReactSelectOption } from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces";

/**
 * Used to filter already used fields from all fields
 * Mostly used in react-select
 * arrays - can be any array
 */
const filterUsedFieldsWithArrays =(
  arrayAll: any[],
  arrayExcluded: any[],
  arrayAllKey: string,
  arrayExcludedKey: string
): TReactSelectOption[] => 
  arrayAll?.filter( item => {
   return !arrayExcluded?.find( excluded => excluded[arrayExcludedKey] === item[arrayAllKey] );
  });

export default filterUsedFieldsWithArrays;
